<p-dialog
  #fastMP
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar matéria prima</span>
      <i class="mdi mdi-shape-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2 mt-2">
    <div class="mt-2 col-md-12">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('descricao')"
          (blur)="verificarNome()"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('repeated')">
        {{ displayMessage.descricao.repeated }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
    <div class="mt-2 col-md-12">
      <fast-autocomplete
        #input
        id="field-categoria-servicos"
        placeholder="Categoria Matéria Prima"
        required
        [autoFirst]="false"
        displayField="descricao"
        [value_order]="'descricao'"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [control]="form.get('categoria')"
        (clearSelection)="form.get('categoria').reset()"
        [entityService]="categoriaMateriaPrimaService"
        [actionState]="
          checkDisponibilidade('POST', '', '/categoria_materia_primas')
        "
        [initDataWithEmpty]="true"
        [domain_id]="tokenService.getDomain().id"
        [valueSearchField]="descricao_categoria"
        [searchFieldPath]="'classificacao'"
        [insertType]="'categoria_materia'"
        [messages]="{
          required: 'Selecione uma categoria de matéria prima.',
          typeIs: 'Valor inválido',
          isEmptyValue: 'Inválido: remova os espaços em branco!'
        }"
      ></fast-autocomplete>
    </div>
    <div class="mt-2 col-md-12">
      <fast-autocomplete
        #input
        id="field-unidade"
        placeholder="Unidade"
        required
        [autoFirst]="false"
        displayField="descricao"
        [value_order]="'descricao'"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [control]="form.get('unidade')"
        (clearSelection)="form.get('unidade').reset()"
        [entityService]="unidadeService"
        [domain_id]="tokenService.getDomain().id"
        [actionState]="false"
        [initDataWithEmpty]="true"
        [messages]="{
          required: 'Selecione uma unidade.',
          typeIs: 'Valor inválido',
          isEmptyValue: 'Inválido: remova os espaços em branco!'
        }"
      ></fast-autocomplete>
    </div>
    <div class="mt-2 col-md-12" (click)="localizadorInput.select()">
      <mat-form-field
        class="width-100"
        appearance="outline"
        (click)="localizadorInput.select()"
      >
        <mat-label (click)="localizadorInput.select()">Localizador</mat-label>
        <input
          #localizadorInput
          matInput
          (click)="localizadorInput.select()"
          type="text"
          [formControl]="form.get('localizador')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('localizador').hasError('maxlength')"
      >
        {{ displayMessage.localizador.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('localizador').hasError('isEmptyValue')"
      >
        {{ displayMessage.localizador.isEmptyValue }}
      </small>
    </div>
    <div class="mt-2 col-md-6" (click)="qtdInput.select()">
      <mat-form-field
        class="width-100"
        appearance="outline"
        (click)="qtdInput.select()"
      >
        <mat-label (click)="qtdInput.select()">Quantidade</mat-label>
        <input
          #qtdInput
          matInput
          (click)="qtdInput.select()"
          type="text"
          [formControl]="form.get('quantidade')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('required')"
      >
        {{ displayMessage.quantidade.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('max_value')"
      >
        {{ displayMessage.quantidade.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('before_split')"
      >
        {{ displayMessage.quantidade.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('after_split')"
      >
        {{ displayMessage.quantidade.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('errorComma')"
      >
        {{ displayMessage.quantidade.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('errorDots')"
      >
        {{ displayMessage.quantidade.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('notNumbers')"
      >
        {{ displayMessage.quantidade.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('quantidade').hasError('invalidNumber')"
      >
        {{ displayMessage.quantidade.invalidNumber }}
      </small>
    </div>
    <div class="mt-2 col-md-6" (click)="qtdMinInput.select()">
      <mat-form-field
        class="width-100"
        appearance="outline"
        (click)="qtdMinInput.select()"
      >
        <mat-label (click)="qtdMinInput.select()">Quantidade mínima</mat-label>
        <input
          #qtdMinInput
          matInput
          (click)="qtdMinInput.select()"
          type="text"
          [formControl]="form.get('qtd_minima')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('required')"
      >
        {{ displayMessage.qtd_minima.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('max_value')"
      >
        {{ displayMessage.qtd_minima.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('before_split')"
      >
        {{ displayMessage.qtd_minima.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('after_split')"
      >
        {{ displayMessage.qtd_minima.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('errorComma')"
      >
        {{ displayMessage.qtd_minima.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('errorDots')"
      >
        {{ displayMessage.qtd_minima.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('notNumbers')"
      >
        {{ displayMessage.qtd_minima.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_minima').hasError('invalidNumber')"
      >
        {{ displayMessage.qtd_minima.invalidNumber }}
      </small>
    </div>
    <div class="flex align-item-center">
      <div class="mt-2 col-md-6" *ngIf="descricao_categoria === 'TECIDO'">
        <mat-form-field class="width-100" appearance="outline">
          <mat-label>Taxa de largura</mat-label>
          <input
            matInput
            (keydown)="validateOnlyNumbers($event)"
            type="text"
            [formControl]="form.get('taxa_conversao')"
            style="text-align: right;"
          />
        </mat-form-field>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('required')"
        >
          {{ displayMessage.taxa_conversao.required }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('valueMinZero')"
        >
          {{ displayMessage.taxa_conversao.valueMinZero }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('min')"
        >
          {{ displayMessage.taxa_conversao.min }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('max_value')"
        >
          {{ displayMessage.taxa_conversao.max_value }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('before_split')"
        >
          {{ displayMessage.taxa_conversao.before_split }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('after_split')"
        >
          {{ displayMessage.taxa_conversao.after_split }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('errorComma')"
        >
          {{ displayMessage.taxa_conversao.errorComma }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('errorDots')"
        >
          {{ displayMessage.taxa_conversao.errorDots }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('notNumbers')"
        >
          {{ displayMessage.taxa_conversao.notNumbers }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('taxa_conversao').hasError('invalidNumber')"
        >
          {{ displayMessage.taxa_conversao.invalidNumber }}
        </small>
      </div>
      <div
        (click)="vlInput.select()"
        [class]="
          descricao_categoria === 'TECIDO' ? 'mt-2 col-md-6' : 'mt-2 col-md-12'
        "
      >
        <mat-form-field
          (click)="vlInput.select()"
          class="width-100"
          appearance="outline"
        >
          <mat-label (click)="vlInput.select()">Valor</mat-label>
          <input
            #vlInput
            matInput
            (click)="vlInput.select()"
            (keydown)="validateOnlyNumbers($event)"
            type="text"
            [formControl]="form.get('valor')"
            style="text-align: right;"
          />
          <span matPrefix *ngIf="form.get('valor').value">R$&nbsp;</span>
        </mat-form-field>
        <small class="p-error" *ngIf="form.get('valor').hasError('required')">
          {{ displayMessage.valor.required }}
        </small>
        <small class="p-error" *ngIf="form.get('valor').hasError('min')">
          {{ displayMessage.valor.min }}
        </small>
        <small class="p-error" *ngIf="form.get('valor').hasError('max_value')">
          {{ displayMessage.valor.max_value }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('valor').hasError('before_split')"
        >
          {{ displayMessage.valor.before_split }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('valor').hasError('after_split')"
        >
          {{ displayMessage.valor.after_split }}
        </small>
        <small class="p-error" *ngIf="form.get('valor').hasError('errorComma')">
          {{ displayMessage.valor.errorComma }}
        </small>
        <small class="p-error" *ngIf="form.get('valor').hasError('errorDots')">
          {{ displayMessage.valor.errorDots }}
        </small>
        <small class="p-error" *ngIf="form.get('valor').hasError('notNumbers')">
          {{ displayMessage.valor.notNumbers }}
        </small>
        <small
          class="p-error"
          *ngIf="form.get('valor').hasError('invalidNumber')"
        >
          {{ displayMessage.valor.invalidNumber }}
        </small>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
